<!--
 * @Author: filename
 * @Description: 高才申请人信息 - 工作经历编辑
-->
<template>
    <div class="user-container common-part">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="140px"
            class="demo-ruleForm"
        >
            <el-row :gutter="10">
                <!-- 高才A类 - 收入种类 -->
                <el-col :span="24" v-if="Number(applicationType) === 1">
                    <el-form-item label="收入种类：" prop="type_of_income">
                        <el-select
                            v-model="form.type_of_income"
                            placeholder="请选择"
                            clearable
                            multiple
                            style="width: 320px;"
                        >
                            <el-option
                                v-for="item in CONFIG.INCOMING_TYPE"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="用人单位：" prop="company_name">
                        <el-input
                            v-model="form.company_name"
                            placeholder="请输入"
                            clearable
                            auto-complete="off"
                            maxlength="50"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="职业：" prop="career">
                        <el-input
                            v-model="form.career"
                            placeholder="请输入"
                            clearable
                            auto-complete="off"
                            maxlength="50"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="界别：" prop="company_type">
                        <el-select
                            v-model="form.company_type"
                            placeholder="请选择"
                            clearable
                        >
                            <el-option
                                v-for="item in CONFIG.BOUNDARY_TYPE"
                                :label="item.name"
                                :value="item.value"
                                :key="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        v-if="form.company_type === '其它 （请注明）'"
                        label="其它 （请注明）："
                        prop="company_type_other"
                    >
                        <el-input
                            v-model="form.company_type_other"
                            placeholder="请输入"
                            clearable
                            auto-complete="off"
                            maxlength="50"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="入职年月：" prop="entry_time">
                        <el-date-picker
                            v-model="form.entry_time"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="请选择">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="离职年月：" :prop="form.work_to_now != 1 ? 'departure_time' : ''">
                        <el-row>
                            <el-col v-if="form.work_to_now != 1" :span="17">
                                <el-date-picker
                                    v-model="form.departure_time"
                                    type="month"
                                    value-format="yyyy-MM"
                                    placeholder="请选择">
                                </el-date-picker>
                            </el-col>
                            <el-col :span="5">
                                <el-checkbox
                                    v-model="form.work_to_now"
                                    :style="{ 'margin-left': form.work_to_now == 0 ? '20px' : '0' }"
                                    label="至今"
                                    :true-label="1"
                                    :false-label="0"
                                    @change="endTimeNow"
                                >
                                    至今
                                </el-checkbox>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="24">
                    <el-form-item label="发薪单位地点：" prop="entry_time">
                        <CurrentAddress
                            ref="CurrentAddress"
                            v-model="form.payroll_unit_location"
                            :isDetails="false"
                            :isLiveOversea="false"
                        />
                    </el-form-item>
                </el-col> -->
                <!-- 来源公司类型 -->
                <el-col :span="12">
                    <el-form-item label="来源公司类型：" prop="company_source">
                        <el-select
                            v-model="form.company_source"
                            placeholder="请选择"
                            clearable
                            style="width: 100%;"
                        >
                            <el-option label="来自于你所拥有的公司（包括业务收入及就业薪酬）" :value="1" />
                            <el-option label="来自于其他公司的就业收入" :value="2" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- 评税文件所属国家/地区 -->
                <el-col :span="12">
                    <el-form-item label="评税文件所属国家/地区：" prop="tax_assessment_address">
                        <el-select
                            v-model="form.tax_assessment_address"
                            placeholder="请选择"
                            clearable
                            style="width: 100%;"
                        >
                            <el-option label="中国内地" :value="1" />
                            <el-option label="中国港澳台" :value="2" />
                            <el-option label="海外" :value="3" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- 收入来源 - 仅在来源公司类型=1时显示 -->
                <el-col :span="24" v-if="form.company_source === 1">
                    <el-form-item label="收入来源：" prop="income_source">
                        <el-select
                            v-model="form.income_source"
                            placeholder="请选择"
                            clearable
                            multiple
                            style="width: 320px;"
                        >
                            <el-option label="业务收入" :value="1" />
                            <el-option label="就业收入" :value="2" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- 业务收入分支 - 仅在收入来源包含'业务收入'时显示 -->
                <template v-if="form.company_source === 1 && form.income_source && form.income_source.includes(1)">
                    <!-- 评税周期 - 仅在评税地区为2或3时显示（港澳台/海外） -->
                    <template v-if="form.tax_assessment_address === 2 || form.tax_assessment_address === 3">
                        <!-- 评税周期开始时间 -->
                        <el-col :span="12">
                            <el-form-item label="评税周期开始时间：" prop="tax_assessment_start_time">
                                <el-date-picker
                                    v-model="form.tax_assessment_start_time"
                                    type="month"
                                    value-format="yyyy-MM"
                                    placeholder="选择年月"
                                    style="width: 100%;"
                                />
                            </el-form-item>
                        </el-col>
                        <!-- 评税周期结束时间 - 自动计算，禁用选择 -->
                        <el-col :span="12">
                            <el-form-item label="评税周期结束时间：" prop="tax_assessment_end_time">
                                <el-date-picker
                                    v-model="form.tax_assessment_end_time"
                                    type="month"
                                    value-format="yyyy-MM"
                                    placeholder="自动计算"
                                    style="width: 100%;"
                                    disabled
                                />
                            </el-form-item>
                        </el-col>
                    </template>
                    <!-- 持股开始时间 -->
                    <el-col :span="12">
                        <el-form-item label="持股开始时间：" prop="shareholding_start_time">
                            <el-date-picker
                                v-model="form.shareholding_start_time"
                                type="month"
                                value-format="yyyy-MM"
                                placeholder="选择年月"
                                style="width: 100%;"
                                :disabled="isShareholdingTimeDisabled"
                            />
                        </el-form-item>
                    </el-col>
                    <!-- 持股结束时间 -->
                    <el-col :span="12">
                        <el-form-item label="持股结束时间：" prop="shareholding_end_time">
                            <el-date-picker
                                v-model="form.shareholding_end_time"
                                type="month"
                                value-format="yyyy-MM"
                                placeholder="选择年月"
                                style="width: 100%;"
                                :disabled="isShareholdingTimeDisabled"
                            />
                        </el-form-item>
                    </el-col>
                    <!-- 持股比例 - 仅在评税地区为2或3时显示（港澳台/海外） -->
                    <el-col :span="12">
                        <el-form-item label="持股比例：" prop="shareholding_percentage">
                            <el-input
                                v-model="form.shareholding_percentage"
                                placeholder="请输入持股比例"
                                clearable
                                auto-complete="off"
                                @input="onShareholdingPercentageInput"
                            >
                                <template slot="append">%</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </template>
                <el-col :span="24">
                    <el-form-item label-width="200px" label="工作证明是否可以提供?" prop="has_work_certificate">
                        <el-radio-group v-model="form.has_work_certificate">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { addOrderWork, updateOrderWork } from "../../../../../api/highTalent"
import CONFIG from "../../config"
import dayjs from 'dayjs'
export default {
    props: {
        currentItem: {
            type: Object,
            default() {
                return {}
            },
        },
        applicationType: {
            type: Number | String,
            default:() => ''
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    created() {
        const info = JSON.parse(JSON.stringify(this.currentItem))
        if (!info.payroll_unit_location) {
            info.payroll_unit_location = {
                area: [],
                country: '',
                details: '',
                foreign: '',
            }
        } else {
            info.payroll_unit_location = info.payroll_unit_location
        }

        if (!info.has_work_certificate) {
            info.has_work_certificate = ''
        }

        // 初始化新字段
        if (!info.company_source) {
            info.company_source = ''
        }
        if (!info.tax_assessment_address) {
            info.tax_assessment_address = ''
        }

        // 处理 income_source 多选数据: 字符串转数组
        if (info.income_source) {
            if (typeof info.income_source === 'string') {
                info.income_source = info.income_source.split(',').map(item => Number(item.trim()))
            }
        } else {
            info.income_source = []
        }

        // 初始化业务收入相关字段
        if (!info.shareholding_start_time) {
            info.shareholding_start_time = ''
        }
        if (!info.shareholding_end_time) {
            info.shareholding_end_time = ''
        }
        if (!info.shareholding_percentage) {
            info.shareholding_percentage = ''
        }
        if (!info.tax_assessment_start_time) {
            info.tax_assessment_start_time = ''
        }
        if (!info.tax_assessment_end_time) {
            info.tax_assessment_end_time = ''
        }

        this.form = info

        // 新增数据时，根据条件自动设置持股时间
        this.$nextTick(() => {
            this.initShareholdingTime()
        })
    },
    data() {
        const validateShareholdingPercentage = (rule, value, callback) => {
            const raw = value === undefined || value === null ? '' : String(value).trim()
            if (!raw) {
                callback(new Error("请输入持股比例"))
                return
            }
            // 0-100，且最多两位小数；100 仅允许 100/100.0/100.00
            const validPattern = /^(100(\.0{1,2})?|([0-9]|[1-9]\d)(\.\d{1,2})?)$/
            if (!validPattern.test(raw)) {
                callback(new Error("请输入0-100之间的数字，最多两位小数"))
                return
            }
            callback()
        }
        return {
            CONFIG,
            rules: {
                company_name: [{required: true, message: "请输入", trigger: "blur"}],
                career: [{required: true, message: "请输入", trigger: "blur"}],
                company_type: [{required: true, message: "请选择", trigger: "change"}],
                company_type_other: [{required: true, message: "请输入", trigger: "blur"}],
                entry_time: [{required: true, message: "请选择", trigger: "change"}],
                departure_time: [{required: true, message: "请选择", trigger: "change"}],
                has_work_certificate: [{required: true, message: "请选择", trigger: "change"}],
                type_of_income: [{required: true, message: "请选择", trigger: "change"}],
                // 新增字段校验
                company_source: [{required: true, message: "请选择来源公司类型", trigger: "change"}],
                tax_assessment_address: [{required: true, message: "请选择评税文件所属国家/地区", trigger: "change"}],
                income_source: [{required: true, message: "请选择收入来源", trigger: "change"}],
                shareholding_start_time: [{required: true, message: "请选择持股开始时间", trigger: "change"}],
                shareholding_end_time: [{required: true, message: "请选择持股结束时间", trigger: "change"}],
                shareholding_percentage: [
                    {required: true, message: "请输入持股比例", trigger: "blur"},
                    {validator: validateShareholdingPercentage, trigger: "blur"}
                ],
                tax_assessment_start_time: [{required: true, message: "请选择评税周期开始时间", trigger: "change"}],
                tax_assessment_end_time: [{required: true, message: "请选择评税周期结束时间", trigger: "change"}],
            },
            form: {}
        }
    },
    computed: {
        /**
         * @description 判断持股时间是否禁用
         * 业务收入时：内地自动设置上一整年，港澳台/海外跟随评税周期
         */
        isShareholdingTimeDisabled() {
            // 收入来源包含业务收入时，持股时间都禁用（自动计算）
            return this.form.company_source === 1 &&
                   this.form.income_source &&
                   this.form.income_source.includes(1)
        }
    },
    watch: {
        /**
         * @description 监听评税地区变化，自动设置持股时间
         */
        'form.tax_assessment_address': {
            handler(newVal, oldVal) {
                // 仅在收入来源包含业务收入时处理
                if (!(this.form.company_source === 1 && this.form.income_source && this.form.income_source.includes(1))) {
                    return
                }

                if (newVal === 1) {
                    // 内地：持股时间固定为上一个整年
                    this.setLastYearShareholdingTime()
                    // 从港澳台/海外切换到内地时，清空评税周期字段
                    if (oldVal === 2 || oldVal === 3) {
                        this.clearTaxAssessmentFields()
                    }
                } else if (newVal === 2 || newVal === 3) {
                    // 港澳台/海外：如果已有评税周期开始时间，则联动计算
                    if (this.form.tax_assessment_start_time) {
                        this.calculateTimesFromTaxStart(this.form.tax_assessment_start_time)
                    } else {
                        // 清空持股时间，等待用户选择评税周期开始时间
                        this.form.shareholding_start_time = ''
                        this.form.shareholding_end_time = ''
                    }
                }
            },
            immediate: false
        },
        /**
         * @description 监听收入来源变化
         */
        'form.income_source': {
            handler(newVal) {
                // 当收入来源包含业务收入时，根据评税地区设置持股时间
                if (this.form.company_source === 1 && newVal && newVal.includes(1)) {
                    if (this.form.tax_assessment_address === 1) {
                        // 内地：持股时间固定为上一个整年
                        this.setLastYearShareholdingTime()
                    } else if (this.form.tax_assessment_address === 2 || this.form.tax_assessment_address === 3) {
                        // 港澳台/海外：如果已有评税周期开始时间，则联动计算
                        if (this.form.tax_assessment_start_time) {
                            this.calculateTimesFromTaxStart(this.form.tax_assessment_start_time)
                        }
                    }
                }
            },
            deep: true,
            immediate: false
        },
        /**
         * @description 监听评税周期开始时间变化（港澳台/海外）
         */
        'form.tax_assessment_start_time': {
            handler(newVal) {
                // 仅在港澳台/海外时处理
                if (this.form.tax_assessment_address === 2 || this.form.tax_assessment_address === 3) {
                    if (newVal) {
                        this.calculateTimesFromTaxStart(newVal)
                    }
                }
            },
            immediate: false
        }
    },
    methods: {
        /**
         * @description 初始化持股时间（编辑模式或新增模式）
         */
        initShareholdingTime() {
            // 仅在收入来源包含业务收入时处理
            if (!(this.form.company_source === 1 && this.form.income_source && this.form.income_source.includes(1))) {
                return
            }

            // 如果是编辑模式且已有持股时间数据，不自动覆盖
            const hasExistingData = this.form.shareholding_start_time && this.form.shareholding_end_time

            if (this.form.tax_assessment_address === 1) {
                // 内地：如果没有已有数据，设置为上一整年
                if (!hasExistingData) {
                    this.setLastYearShareholdingTime()
                }
            } else if (this.form.tax_assessment_address === 2 || this.form.tax_assessment_address === 3) {
                // 港澳台/海外：如果有评税周期开始时间，联动计算
                if (this.form.tax_assessment_start_time) {
                    this.calculateTimesFromTaxStart(this.form.tax_assessment_start_time)
                }
            }
        },
        /**
         * @description 设置上一个整年的持股时间（内地）
         */
        setLastYearShareholdingTime() {
            const lastYear = dayjs().year() - 1
            this.form.shareholding_start_time = `${lastYear}-01`
            this.form.shareholding_end_time = `${lastYear}-12`
        },
        /**
         * @description 根据评税周期开始时间计算其他时间（港澳台/海外）
         * 评税周期结束 = 评税周期开始 + 11个月
         * 持股开始时间 = 评税周期开始
         * 持股结束时间 = 评税周期结束
         */
        calculateTimesFromTaxStart(startTime) {
            if (!startTime) return

            // 评税周期结束 = 开始 + 11个月
            const endTime = dayjs(startTime).add(11, 'month').format('YYYY-MM')
            this.form.tax_assessment_end_time = endTime

            // 持股时间 = 评税周期
            this.form.shareholding_start_time = startTime
            this.form.shareholding_end_time = endTime
        },
        /**
         * @description 清空评税周期相关字段（从港澳台/海外切换到内地时）
         */
        clearTaxAssessmentFields() {
            this.form.tax_assessment_start_time = ''
            this.form.tax_assessment_end_time = ''
        },
        /**
         * @description 校验
         */
         async checkInfo() {
            try {
                await this.$refs.form.validate()
                this.saveInfo()
            } catch (error) {
                this.$utils.scrollIntoError(this)
            }
        },
        /**
         * @description 保存
         */
        async saveInfo() {
            try {
                this.$emit("update:loading", true)
                if (this.form.id === 0) delete this.form.id

                // 处理 income_source 多选数据: 数组转字符串(或根据后端要求保持数组格式)
                const formData = JSON.parse(JSON.stringify(this.form))
                if (formData.income_source && Array.isArray(formData.income_source)) {
                    // 如果后端需要字符串格式,取消下面这行的注释
                    // formData.income_source = formData.income_source.join(',')
                }

                const fn = this.form.id ? updateOrderWork : addOrderWork
                const { code, data } = await fn(formData)
                if (code === 200) {
                    this.$message.success("保存成功")
                    // this.form.isEdit = false
                    await this.$utils.saveHighTalentStatus(
                        this.$route.params.id
                    )
                }
            } finally {
                this.$emit("update:loading", false)
            }
        },
        /**
         * @description 至今选项
         */
        endTimeNow(e) {
            if (e) {
                this.form.departure_time = ''
            }
        },
        onShareholdingPercentageInput(value) {
            if (value === undefined || value === null || value === '') {
                this.form.shareholding_percentage = ''
                return
            }

            // 仅保留数字和小数点
            let normalized = String(value).replace(/[^\d.]/g, '')
            // 小数点不能在首位
            normalized = normalized.replace(/^\./, '')

            const parts = normalized.split('.')
            const integerPart = parts[0] || ''
            const decimalPart = parts.length > 1 ? parts.slice(1).join('').slice(0, 2) : ''

            normalized = parts.length > 1 ? `${integerPart}.${decimalPart}` : integerPart

            if (normalized) {
                const num = Number(normalized)
                if (!Number.isNaN(num) && num > 100) {
                    normalized = '100'
                }
            }

            this.form.shareholding_percentage = normalized
        },
    },
};
</script>

<style lang="less" scoped>
.certificates_info {
    margin: 4px 0 0 0;
    font-size: 11px;
    line-height: 11px;
    color: #606266;
}
.declaration_radio {
    .el-radio {
        margin: 8px 0;
    }
}
</style>
